import axios from 'axios';

export const userPreferencesService = {
    /** Every tab at once. The only read — list endpoints never return preferences. */
    getPreferencesService: () => axios.get('/user-preferences', { auth: true }),

    /** Replaces one tab's state wholesale. Answers 204 with no body. */
    saveTabFiltersService: (tab, filters) => axios.put(`/user-preferences/filters/${tab}`, { filters }, { auth: true }),

    clearTabFiltersService: (tab) => axios.delete(`/user-preferences/filters/${tab}`, { auth: true }),
};
